import { a, i, title } from "framer-motion/client";



const SidebarData = [
  {
    label: "iXiMANAGER",
    isMainMenu: true
  },
  {
    label: "Accueil",
    icon: "mdi mdi-home-outline",
    isHasArrow: true,
    url: "/landing",
    activeOnAdditionalPaths: ["/landing/"],
  },
  // Menu déroulant iXiVERSE Services
  /*{
    label: "Services +",
    icon: "mdi mdi-creation",
    isHasArrow: false,
    url: "services",
    subItem: [
      { sublabel: "Modéle 3D", link: "/3Dmodels", title: "Bibliothèque 3D\net demande de modélisation d'objets 3D", icon: "mdi mdi-cube-outline", activeOnAdditionalPaths: ["/3Dmodels/"] },
      { sublabel: "Photoscan 3D", link: "/photoscans", title: "Demande de Photogrammétrie\net environnements 360° ", icon: "mdi mdi-cube-scan", activeOnAdditionalPaths: ["/photoscans/"] },
      { sublabel: "Développement", link: "/development", title: "Demande de développements spécifiques", icon: "mdi mdi-dna", activeOnAdditionalPaths: ["/development/"] },
      { sublabel: "Support", link: "/support", title: "Aide et assistance", icon: "mdi mdi-handshake-outline", activeOnAdditionalPaths: ["/support/"] },
      { sublabel: "Build d'application", link: "/builds", title: "Demande d'application autonome (APK)", icon: "mdi mdi-package-variant", activeOnAdditionalPaths: ["/builds/"] },
    ],
  },*/

  // Super Admin Block ATTENTION A L'ORDRE, TOUS EN DESSOUS SERONT CACHE SI PAS ADMIN
  {
    label: "Gestion",
    isMainMenu: true,
    isAdminBlock: true, // <- marque ce bloc pour filtrage
  },
  {
    label: "Tableau de bord",
    title: "Statistiques globales de la plateforme",
    isHasArrow: true,
    url: "/dashboard",
    icon: "mdi mdi-chart-areaspline",
    activeOnAdditionalPaths: ["/dashboard/"]
  },
  {
    label: "Utilisateurs",
    title: "Gestion des Utilisateurs\nStatistiques et édition des comptes",
    isHasArrow: true,
    url: "/users",
    icon: "mdi mdi-account-group",
    activeOnAdditionalPaths: ["/users/", "/user-dashboard/", "/user/"],
  },
  {
    label: "Créateurs",
    title: "Gestion des comptes Créateurs",
    icon: "mdi mdi-account-multiple-outline",
    isHasArrow: true,
    url: "/adminManage",
    //activeOnAdditionalPaths: ["/adminManage/", "/chapterManage/", "/languageManageWork/", "/homemono/"],
  },
  {
    label: "Administeurs",
    title: "Gestion des administrateurs et créations de compte admin",
    isHasArrow: true,
    url: "/admins",
    icon: "mdi mdi-account-tie",
    activeOnAdditionalPaths: ["/admins/"]
  },
  /*{
    label: "iXiWORK [APK]",
    title: "[UTILISATEURS] \nApplication XR de lecture des contenus",
    isHasArrow: true,
    url: "/ixiwork",
    icon: "mdi mdi-arrow-down-bold-hexagon-outline",
    activeOnAdditionalPaths: ["/ixiwork/"]
  },*/
  {
    label: "Liste de contenus",
    title: "[UTILISATEURS] \nApplication XR de lecture des contenus",
    isHasArrow: true,
    url: "/listContenuRefAdmin",
    icon: "dripicons-view-list",
    activeOnAdditionalPaths: ["/listContenuRefAdmin/"]
  },


  // CREATORS Block
  {
    label: "iXiMAKER pro",
    isMainMenu: true
  },
  {
    label: "Référentiels",
    title: "[CREATEURS]\nApplication XR de variantes de contenus",
    icon: "mdi mdi-folder-outline",
    isHasArrow: true,
    url: "/ixivariant",
    activeOnAdditionalPaths: ["/ixivariant/"]
  },
  {
    label: "iXiPLACE [APK]",
    title: "[CREATEURS]\nApplication XR de spatialisation des contenus",
    icon: "mdi mdi-arrow-down-bold-hexagon-outline",
    isHasArrow: true,
    url: "/ixiplace",
    activeOnAdditionalPaths: ["/ixiplacer/"]
  },
  {
    label: "Parc XR",
    title: "Gestion des casques XR\nAssignation des utilisateurs et des contenus",
    isHasArrow: true,
    url: "/headset",
    icon: "bx bxs-mask",
    activeOnAdditionalPaths: ["/headset/"]
  },
  {
    label: "iXiMultiScreen",
    title: "[SUPER ADMIN / ADMIN / CREATEURS]\nTéléchargement de l'application iXiMultiScreen",
    icon: "mdi mdi-download",
    isHasArrow: true,
    url: "/ixi-multiscreen",
    activeOnAdditionalPaths: ["/ixi-multiscreen/"],
    roles: [1, 2, 4]
  },

  // Super Admin Block
  {
    label: "Super Admin",
    isMainMenu: true,
    isSuperAdminBlock: true
  },
  {
    label: "Super Admin",
    icon: "mdi mdi-account-cowboy-hat",
    isHasArrow: true,
    url: "/listsuperadmin",
    activeOnAdditionalPaths: ["/listsuperadmin/"],
  },
  {
    label: "Calendrier",
    icon: "mdi mdi-calendar-outline",
    isHasArrow: true,
    url: "/calendar",
    activeOnAdditionalPaths: ["/calendar/"],
  },
  {
    label: "Icônes",
    icon: "mdi mdi-image-edit-outline",
    isHasArrow: true,
    url: "/iconsMdi",
    activeOnAdditionalPaths: ["/iconsMdi/"],
  },
  {
    label: "Admins",
    title: "Gestion des administrateurs",
    icon: "mdi mdi-account-tie",
    isHasArrow: true,
    url: "/auth-register",
  },
  {
    label: "Logs (wip)",
    icon: "mdi mdi-file-document-outline",
    isHasArrow: true,
    url: "/logs",
  }
];
export default SidebarData;
